import React from 'react';
import { useAppVersion } from '../../hooks/useAppVersion';

const UpdateToast = () => {
  const { hasUpdate } = useAppVersion();

  if (!hasUpdate) return null;

  return (
    <div className="update-toast">
      <span className="update-toast__message">A new version is available</span>
      <button className="update-toast__btn" onClick={() => window.location.reload()}>
        Reload
      </button>
    </div>
  );
};

export default UpdateToast;
